import './../styles/TopNavBar.css'
import { Link } from 'react-router-dom';


const TopNavBar = () => {
    return (
        <div id="navBar">
            <div id="containerLeft">
                <Link to="/" className="navLinkLeft">Home</Link>
                <Link to="/lessons" className="navLinkLeft">Lessons</Link>
                <Link to="/programs" className="navLinkLeft">Programs</Link>
                <Link to="/media" className="navLinkLeft">Media</Link>
            </div>
            <div id="containerRight">
                <Link to="/merch" className="navLinkRight">Merchandise</Link>
                <Link to="/donate" className="navLinkRight">Donate</Link>
                <Link to="/contact" className="navLinkRight">Contact Us</Link>
            </div>
        </div>
    );
}

export default TopNavBar;